<template>
	<div>
	   <div class="waga" v-show="show">
		<div class="stitle"> {{ title }} </div>
		<div class="wrap">
    			<ejs-numerictextbox value="0" format="###" :min="0" cssClass="e-style"></ejs-numerictextbox>
			<label>odczyt wagi</label>
		</div>
		<div class='wrap'>
    			<ejs-numerictextbox value="0" format="###" :min="0" cssClass="e-style"></ejs-numerictextbox>
			<label>samodzielne wpisanie wagi</label>
		</div>
		<button class="commit"> {{ titleCommit }} </button>
	    </div>
            <div class="podwaga">
                <div class="wroc">
                        <button id="wroc"> WRÓĆ </button>
                </div>
            </div>
	</div>
</template>

<script>

import { NumericTextBoxComponent } from "@syncfusion/ej2-vue-inputs";
import "../../node_modules/@syncfusion/ej2-base/styles/material.css";
import "../../node_modules/@syncfusion/ej2-vue-inputs/styles/material.css";

export default {
  name: "artykulwaga",
  components: { 
        "ejs-numerictextbox": NumericTextBoxComponent,
  },
  props: {
    nazwa: String,
    ident: Number,
    dataLoading: Boolean,
  },
  data: () => ({
        title: "POŁÓŻ TOWAR NA WADZE",
	titleCommit: "PRZYJĘCIE NA STAN",
	show: true,
  }),
  methods: {
	wrocclick() {
		this.$router.push({ path: "/artykul" });
	},
	commitclick() {
		alert("Zatwiedź");
	}
  },
  mounted() {
	let that = this;
    	this.$root.$on("update:waga", val1 => {
		if (val1 != null) {
			var vals = new String(val1);
			var ids = vals.split(",");
			//console.log("IDS: " + ids);
			//console.log("IDENT:" + that.ident);
			if (ids.includes("" + that.ident)) {
				console.log("FOUND!");
				that.show = true;
			} else {
				that.show = false;
			}
		}
    	});
	document.querySelector(".wroc").addEventListener('click', function() { that.wrocclick(); } );
	document.querySelector(".commit").addEventListener('click', function() { that.commitclick(); } );
  }
} 

</script>

<style>

.e-numeric.e-style .e-control.e-numerictextbox {
        color: royalblue;
        font-size: xx-large;
        border: 0px;
    }

/* csslint ignore:start */
    .e-numeric .e-input-group-icon.e-spin-up:before {
        content: "\e823";
        color: rgba(0, 0, 0, 0.54);
    }

    .e-numeric .e-input-group-icon.e-spin-down:before {
        content: "\e934";
        color: rgba(0, 0, 0, 0.54);
    }
    /* csslint ignore:end */

.wroc {
        width: 100%;
        height: 10%;
        text-align: left;
	float:left;
}
.podwaga {
        clear:both;
        margin-top: 30px;
}
.waga {
	margin-bottom:5%;
}
.commit {
	width: 200px;
	height: 50px;
}

.nazwa {
}

.stitle {
	color:red;
}

.wrap {
margin: 5% auto;
width: 240px;
}
.wroc {
        width: 200px;
        height: 50px;
        position:relative;
        text-align: left;
        background-color: #FFFFFF;
        float: left;
        margin-top: 40px;
        margin-left: 400px;
}
#wroc {
        width: 200px;
        height: 50px;
        position:relative;
        background-color: #FFFFFF;
}


</style>




// WEBPACK FOOTER //
// src/components/ArtykulWaga.vue